export default {
  'bulletins.back': 'Back to Dashboard',
  'bulletins.header': 'Bulletins',
  'bulletins.missing': 'No new Bulletins.',
  'bulletins.new': 'New Bulletins to read.'
};
